import { Box, Flex, Container, Text, HStack } from '@chakra-ui/react'
import { FC } from 'react'
import { IoIosGitNetwork } from 'react-icons/io'

import useSessions from '@hook/shared/use-sessions'

import BackgroundTasksItem from './Item'

const BackgroundTasks: FC = () => {
  const { sessions, hasSessions } = useSessions()

  return (
    <>
      {hasSessions && (
        <Box
          pos="fixed"
          bg="#fff"
          borderTop="solid 1px"
          borderColor="gray.200"
          bottom={0}
          left={0}
          w="100%"
          zIndex={80}
          h="32px"
        >
          <Container
            as={Flex}
            maxW="container.2xl"
            alignItems="flex-end"
            justifyContent="space-between"
            px={8}
          >
            <Flex h="32px" alignItems="flex-start" pt={1} color="gray.500">
              <IoIosGitNetwork size="16px" />
              <Text fontSize="sm" ml={2} mt={-0.5}>
                Sessões em andamento
              </Text>
            </Flex>

            <HStack spacing={2} h="38px" mt={-1}>
              {sessions.map(session => (
                <BackgroundTasksItem
                  key={`session-${session.name
                    .split(' ')
                    .join('-')
                    .toLowerCase()}`}
                  {...session}
                />
              ))}
            </HStack>
          </Container>
        </Box>
      )}
    </>
  )
}

export default BackgroundTasks
